/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {DownloadTemplate} from '@ion/core/src/types/templates';
import {
  CSVExportButton
} from '../buttons/CSVExportButton';
import {
  RefreshGridButton
} from '../buttons/RefreshGridButton';

export interface GridActionProps {
  onExport?: (params?: DownloadTemplate) => void;
  isExporting?: boolean;
  onRefresh?: (params?: boolean) => void;
}

const useStyles = makeStyles(() => ({
  gridActionsContainer : {
    display        : 'flex',
    justifyContent : 'end'
  }
}));

/**
 * Displays available grid actions (such as refresh or export) above a grid as a row of icons.
 */
export const GridActions = ({
  onExport,
  onRefresh,
  isExporting = false
}: GridActionProps) => {
  const classes = useStyles();
  return (
    <span className={classes.gridActionsContainer}>
      {onRefresh && <RefreshGridButton onRefresh={onRefresh} />}
      {onExport && <CSVExportButton onExport={onExport} isExporting={isExporting} />}
    </span>
  );
};

export default GridActions;
